'use es6';

import BasePatternFactory from '../lib/BasePatternFactory';
import PasswordRulesRegex from '../regex/PasswordRulesRegex';
export default BasePatternFactory({
  name: 'Password',
  rules: PasswordRulesRegex
});